var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07187 20.2032C3.44216 20.2032 2.90556 19.9814 2.46207 19.538C2.01861 19.0945 1.79688 18.5579 1.79688 17.9282V6.07166C1.79688 5.44194 2.01862 4.90534 2.46213 4.46186C2.90559 4.01837 3.44218 3.79663 4.0719 3.79663H19.9284C20.5581 3.79663 21.0947 4.01837 21.5382 4.46186C21.9817 4.90534 22.2034 5.44194 22.2034 6.07166V17.9282C22.2034 18.5579 21.9817 19.0945 21.5382 19.538C21.0947 19.9814 20.5581 20.2032 19.9284 20.2032H4.07187ZM12.0001 13.257L4.07187 8.25698V17.9282H19.9284V8.25698L12.0001 13.257ZM12.0001 11.0717L19.9284 6.07166H4.07187L12.0001 11.0717ZM4.07187 8.25698V6.07166V17.9282V8.25698Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.668793ca9a865dea3e385cb08cc1dace.svg";
export { ForwardRef as ReactComponent };